import _defineProperty from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsx } from 'react/jsx-runtime';
import cx from 'classnames';
import { useTabs } from './use-tabs.js';
import s from './Tabs.module.scss.js';
var Tab = function Tab(_ref) {
  var value = _ref.value,
    children = _ref.children;
  var _useTabs = useTabs(),
    activeTab = _useTabs.activeTab,
    setActiveTab = _useTabs.setActiveTab,
    tabsRef = _useTabs.tabsRef;
  var isActive = activeTab === value;
  return /* @__PURE__ */jsx("li", {
    className: cx(s.tabs__tab, _defineProperty({}, s.active, isActive)),
    ref: function ref(el) {
      return tabsRef.current[value] = el;
    },
    role: "tab",
    "aria-selected": isActive ? "true" : "false",
    tabIndex: isActive ? 0 : void 0,
    onClick: function onClick() {
      return setActiveTab(value);
    },
    children: children
  });
};
export { Tab };